<template>
    <div class="main">
        <!-- 轮播图 -->
        <div class="banner">
            <img src="../assets/images/22.png" alt="">
        </div>
        <!-- 图集 -->
        <div class="u-flex u-row-between album">
            <div class="album-item" v-for="(item, index) in albumList" :key="index">
                <img :src="item.img" alt="">
                <div class="album-txt">
                    <div class="album-name">{{ item.name }}</div>
                    <div class="album-intro">{{ item.intro }}</div>
                </div>
            </div>
        </div>
        <!-- 精选收藏 -->
        <div class="u-flex u-flex-wrap u-row-between winnow">
            <div class="u-flex u-row-between title">
                <span>精选收藏</span>
            </div>
            <div class="winnow-item" v-for="(item, index) in winnowList" :key="index">
                <img :src="item.img" alt="">
            </div>
        </div>

        <!-- 艺术&生活 -->
        <div class="u-flex u-flex-wrap u-row-between life">
            <div class="u-flex u-row-between title">
                <span>艺术&生活</span>
            </div>
            <div class="life-item" v-for="(item, index) in lifeList" :key="index">
                <img :src="item.img" alt="">
                <div class="life-txt">
                    <div class="life-name">{{ item.name }}</div>
                    <div class="life-intro">{{ item.intro }}</div>
                </div>
            </div>
        </div>
        <!-- 更多探索 -->
        <div class="chosen quest-box">
            <div>
                <div class="u-flex u-row-between title">
                    <span>策展人精选：抽象</span>
                </div>
                <div class="u-flex u-row-between chosen-box">
                    <div class="chosen-item" v-for="(item, index) in chosenList" :key="index">
                        <img class="chosen-img" :src="item.img" alt="">
                        <div class="u-flex chosen-txt">
                            <div class="chosen-name">{{ item.name }}</div>
                        </div>
                        <div class="chosen-price">￥{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            albumList: [
                {
                    intro: '我们鼓励你去探索,培养一种真正属于你自己的自我意识品味和风格, 人类形态的图像是如此富有表现力和发自内心在几何作品中我发现线条、比例和颜色非常令人沉思和愉悦',
                    img: require("../assets/images/23.png"),
                    name: "这就是艺术的价值 "
                },
                {
                    intro: '我们精心策划的美术印刷品为艺术爱好者提供了一种可定制且经济实惠的方式来收集艺术品，这些艺术品一送到您家门口就可以悬挂。',
                    img: require("../assets/images/24.png"),
                    name: "美术版画指南 "
                },
                {
                    intro: '从宁静的海景到欢乐的抽象，用顶级新兴艺术家的独一无二的艺术作品将本季的美丽和幸福带到您的墙壁上。',
                    img: require("../assets/images/25.png"),
                    name: "夏天之最"
                }
            ],
            winnowList: [
                {
                    img: require("../assets/images/23.png"),
                },
                {
                    img: require("../assets/images/24.png"),
                },
                {
                    img: require("../assets/images/25.png"),
                },
                {
                    img: require("../assets/images/23.png"),
                },
                {
                    img: require("../assets/images/24.png"),
                },
                {
                    img: require("../assets/images/25.png"),
                }
            ],
            lifeList: [
                {
                    intro: '发现一些最令人兴奋的艺术他们引起了收藏家和策展人的注意',
                    img: require("../assets/images/26.png"),
                    name: "收藏家收藏夹 "
                },
                {
                    intro: '了解过去的艺术运动如何以新的和令人兴奋的方式激励当今的新兴艺术',
                    img: require("../assets/images/26.png"),
                    name: "艺术历史 "
                },
                {
                    intro: '探索通过艺术和家居装饰表达个人风格的新方式',
                    img: require("../assets/images/26.png"),
                    name: "设计灵感"
                },
                {
                    intro: '了解不可替代代币数字艺术(NET)进入该领域的新兴艺术家以及如何开始收集艺术 NFT',
                    img: require("../assets/images/26.png"),
                    name: "非同质化代币艺术"
                }

            ],
            chosenList: [
                {
                    price: 500,
                    img: require("../assets/images/17.png"),
                    name: "CMW1203A070001"
                },
                {
                    price: 500,
                    img: require("../assets/images/18.png"),
                    name: "CMW1203A070001"
                },
                {
                    price: 500,
                    img: require("../assets/images/19.png"),
                    name: "CMW1203A070001"
                },
                {
                    price: 500,
                    img: require("../assets/images/20.png"),
                    name: "CMW1203A070001"
                },
                {
                    price: 500,
                    img: require("../assets/images/17.png"),
                    name: "CMW1203A070001"
                }
            ]
        }
    },
    methods: {},
    mounted() { }
}
</script>

<style scoped>
.banner img {
    width: 100%;
}

.album {
    margin-top: 54px;
}

.album-item,
.winnow-item {
    width: calc(33.3333% - 15px);
}

.winnow-item {
    margin-bottom: 20px;
}

.album-item img,
.winnow-item img {
    width: 100%;
    display: block;
}

.life-item {
    width: calc(25% - 30px);
}

.life-item img {
    width: 100%;
    display: block;
}

.album-txt,
.life-txt {
    padding: 20px;
    text-align: center;
}

.album-name,
.life-name {
    color: #000;
    font-size: 20px;
}

.album-intro,
.life-intro {
    margin-top: 20px;
    min-height: 60px;
    line-height: 20px;
    color: #999;
    font-size: 16px;
}

.winnow {
    margin-top: 80px;
}

.life {
    margin-top: 80px;
}

.chosen {
    margin-top: 40px;
}

.quest-box {
    margin-top: 50px;
    padding: 50px 0;
    background: #f3f3f3;
}

.title {
    margin-bottom: 50px;
    width: 100%;
    height: 80px;
    line-height: 80px;
    color: #000;
    font-size: 24px;
    border-bottom: 1px solid #000;
}

.slogan {
    color: #999;
    font-size: 14px;
}

.chosen-box {
    margin-top: 28px;
}

.chosen-box>>>.chosen-item {
    width: calc(20% - 20px);
    color: #000;
    font-size: 16px;
}

.chosen-img {
    width: 100%;
}

.chosen-img img {
    width: 100%;
}

.chosen-name {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.chosen-price {
    margin-top: 5px;
    font-weight: 500;
}
</style>